import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {DateAdapter, NativeDateAdapter} from '@angular/material/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDatetimeInputComponent } from '../../../editors/mat-datetime-input/mat-datetime-input.component';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

export interface DateRangeDialogData {
  startDate: Date;
  endDate: Date;
}

@Component({
    selector: 'app-mat-date-range-dialog',
    providers: [
        { provide: DateAdapter, useClass: NativeDateAdapter },
    ],
    templateUrl: './mat-date-range-dialog.component.html',
    styleUrls: ['./mat-date-range-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDatetimeInputComponent, FormsModule, MatDialogActions, MatButton]
})
export class MatDateRangeDialogComponent implements OnInit {

  startDate: Date = new Date();
  endDate: Date = new Date();

  constructor(public dialogRef: MatDialogRef<MatDateRangeDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DateRangeDialogData) {

  }

  ngOnInit() {
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      this.dialogRef.close({
        startDate: this.startDate,
        endDate: this.endDate
      });
    }
  }
}
